import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { PortalAuthService } from '../services/portal-auth.service';

export const portalGuard: CanActivateFn = () => {
  const authService = inject(PortalAuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  const token = authService.getToken();
  if (!token) {
    return router.createUrlTree(['/auth/request-link']);
  }

  return authService.loadCurrentUser().pipe(
    map(() => true),
    catchError(() => of(router.createUrlTree(['/auth/request-link'])))
  );
};
